const INCHES_PER_FOOT = 12;
const CM_PER_INCH = 2.54;

// precision constants suited for medical accuracy
const INCHES_DECIMAL_PRECISION = 2; // 0.01 inch precision (±0.025cm)
const CM_DECIMAL_PRECISION = 5; // High precision for internal calculations to avoid cascading rounding errors

export const inchesToCm = (inches) => {
  return inches * CM_PER_INCH;
};

export const cmToInches = (cm) => {
  return cm / CM_PER_INCH;
};

export const feetInchesToCm = (feetValue, inchesValue, precision = CM_DECIMAL_PRECISION) => {
  const feet = Number(feetValue) || 0;
  const inches = Number(inchesValue) || 0;
  const totalInches = feet * INCHES_PER_FOOT + inches;
  const cm = totalInches * CM_PER_INCH;
  if (Number.isInteger(precision) && precision >= 0) {
    return Number(cm.toFixed(precision));
  }
  return cm;
};

export const cmToFeetInches = (cm, precision = INCHES_DECIMAL_PRECISION) => {
  const totalInches = cm / CM_PER_INCH;
  const feet = Math.floor(totalInches / INCHES_PER_FOOT);
  const inches = totalInches % INCHES_PER_FOOT;
  return {
    feet: feet,
    inches: parseFloat(inches.toFixed(precision)),
  };
};

export const getFeetInchesStrings = (cm) => {
  if (!cm || cm <= 0) {
    return { feet: "", inches: "" };
  }
  const { feet, inches } = cmToFeetInches(cm, 1);
  return {
    feet: feet > 0 ? feet.toString() : "",
    inches: inches > 0 ? inches.toString() : "",
  };
};

export const getHeightInCm = (unit, height, feet, inches) => {
  if (unit === "in") {
    // feet/inches input
    return feetInchesToCm(feet, inches, CM_DECIMAL_PRECISION);
  }
  if (unit === "inches") {
    // direct inches input
    const totalInches = parseFloat(height) || 0;
    const cm = totalInches * CM_PER_INCH;
    return Number(cm.toFixed(CM_DECIMAL_PRECISION));
  }
  // assume cm
  return parseFloat(height) || 0;
};

// unified converter
export function convertHeightUnitsForDisplay({ fromUnit, toUnit, height, feet, inches }) {
  if (fromUnit === toUnit) {
    return { height, feet, inches };
  }
  if (fromUnit === "cm" && toUnit === "in") {
    if (height) {
      const { feet: newFeet, inches: newInches } = getFeetInchesStrings(parseFloat(height));
      return { height: "", feet: newFeet, inches: newInches };
    }
    return { height: "", feet: "", inches: "" };
  }
  if (fromUnit === "in" && toUnit === "cm") {
    const cmValue = feetInchesToCm(feet, inches);
    if (cmValue > 0) {
      return { height: cmValue.toFixed(1), feet: "", inches: "" };
    }
    return { height: "", feet: "", inches: "" };
  }
  return { height: "", feet: "", inches: "" };
}
